import { isOMUser, isPMUser } from "./roles";

export const departmentConfigs = {
	"_GY:O&M": 5,
	"_GY:PM": 6,
};

export function getDepartmentId(roles) {
	switch (true) {
		case isOMUser(roles):
			return departmentConfigs["_GY:O&M"];
		case isPMUser(roles):
			return departmentConfigs["_GY:PM"];
		default:
			return null;
	}
}

export function getDepartmentName(department_id) {
	switch (department_id) {
		case departmentConfigs["_GY:O&M"]:
			return "O&M";
		case departmentConfigs["_GY:PM"]:
			return "PM";
		default:
			return null;
	}
}
